module.exports = __webpack_public_path__ + "img/arrow-trend-down.2ba93dea.svg";